/**
 * InfoItem - Shared icon + text row used inside profile cards.
 *
 * Used by both DeveloperProfilePage and ClientProfilePage in their show-mode
 * profile card info list. Extracted to avoid duplication.
 *
 * Visual spec (Figma node 1350:15713):
 *   - Icon: 20px, text-dark-secondary
 *   - Text: 14px medium, leading-[22px], text-dark-primary
 *   - Gap: 13px
 */

export interface InfoItemProps {
  icon: string;
  text: string;
}

export function InfoItem({ icon, text }: InfoItemProps) {
  return (
    <div className="flex items-center gap-[--spacing-7]">
      <i className={`${icon} text-xl leading-none text-[--text-dark-secondary]`} />
      <span className="text-sm font-medium text-[--text-dark-primary]">{text}</span>
    </div>
  );
}
